import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Disposisi from '../../../utilities/Disposisi';
import { formatDateString, getNamaUPTBaru} from '../../../utilities/Utils';
import MasterService from '../../../services/master/MasterService';
import UserService from '../../../services/user/UserService';
import { FaChevronCircleLeft } from 'react-icons/fa';

const ModalViewProses = ({ showViewProses, handleCloseViewProses, dataDisposisi, datappm }) => {
    // console.log(datappm)
    // const [showConfirmProses, setShowConfirmProses] = useState(false)
    // const handleCloseConfirmProses = () => setShowConfirmProses(false)
    // const [showProsesSuccess, setShowProsesSucces] = useState(false)
    // const [showProsesFailed, setShowProsesFailed] = useState(false)
    // const [rowData, setRowData] = useState(null)

    // let transaksiService = useMemo(() => new TransaksiService(), [])
    let masterService = useMemo(() => new MasterService(), [])
    let userService = useMemo(() => new UserService(), [])
    // const currentDate = new Date()
    // const currentMonth = currentDate.getMonth() + 1
    // const currentYear = currentDate.getFullYear()

    const [negPartner, setNegPartner] = useState(null)
    const [jnsKomoditi, setJnsKomoditi] = useState(null)
    const [maksudKegiatan, setMaksudKegiatan] = useState(null)
    const [upt, setUpt] = useState(null)
    // let navigate = useNavigate()
    useEffect(() => {
        if(!datappm) return
        const fetchRef = async () => {
            try {
                const resNegTujuan = await masterService.getNegaraById(datappm.negaraPartner)
                setNegPartner(resNegTujuan.data.uraianNegara)

                const resJenisKomoditi = await masterService.getJenisKomoditiById(datappm.jenisKomoditi)
                setJnsKomoditi(resJenisKomoditi.data.jenisKomoditi)

                const resMaksud = await masterService.getMaksudPengirimanById(datappm.maksudKegiatan)
                setMaksudKegiatan(resMaksud.data.maksudPengiriman)

                const resUpt = await userService.getUptById(datappm.kdUpt)
                setUpt(getNamaUPTBaru(datappm.tanggalAju, resUpt.data))

            } catch (error) {
                setNegPartner(null)
                setJnsKomoditi(null)
                setMaksudKegiatan(null)
            }
        }
        fetchRef()
    }, [datappm, masterService, userService])

    // const ProsesDisposisi = (dataPenugasan) => {
    //     setShowConfirmProses(true)
    //     setRowData(dataPenugasan)
    // }

    // const handleClickProses = async () => {
    //     setShowConfirmProses(false)
    //     try {
    //         console.log(rowData)
    //         let jsonSppEvp = {
    //             idDisposisi: 2,
    //             nomorAju: datappm.nomorAju
    //         }
    //         let jsonppm = { ...datappm, status: '020' }

    //         let noSuratTugasTemp = datappm.kdUpt + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + Math.floor(100000 + Math.random() * 900000)
    //         let jsonProses = { ...rowData, noTugas: 'PPM/E/' + noSuratTugasTemp, tglTugas: getCurrentDateFormatted(), createdBy: localStorage.getItem("userId") }

    //         const response = await transaksiService.addPenugasan(jsonSppEvp)
    //         if (response.data.kode === '200') {
    //             setShowProsesSucces(true)
    //             setShowConfirmProses(false)

    //             await transaksiService.addPpm(jsonppm)

    //             // let jsonSppDraftHC = {
    //             //     idDisposisi: 4,
    //             //     nomorAju: datappm.nomorAju
    //             // }
    //             // await transaksiService.addPenugasan(jsonSppDraftHC)
    //             await transaksiService.addPenugasan(jsonProses)
    //         } else {
    //             setShowProsesFailed(true)
    //         }
    //     } catch (error) {
    //         console.log(error)
    //         setShowProsesFailed(true)
    //     }
    // }

    // const handleClickProsesSuccess = () => {
    //     setShowProsesSucces(false)
    //     setShowConfirmProses(false)
    //     handleCloseAddProses()
    //     // setShowAddProses(false)
    //     // window.location.reload()
    //     // refresh()
    //     // navigate('/penugasan/daftar')
    //     reloadList(0, 10)
    // }

    // const handleClickProsesFailed = () => {
    //     setShowProsesFailed(false)
    // }

    return (
        <>
            <Modal show={showViewProses}
                onHide={handleCloseViewProses}
                backdrop='static'
                keyboard={false}
                size="lg"
                centered
            >
                <Modal.Header>
                    <Modal.Title><h6><Disposisi idDisposisi={dataDisposisi.idDisposisi} /></h6></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <div className='col-4'>
                            <label className="col-sm-6 col-form-label-sm">Nomor Aju</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} disabled />
                            </div>
                        </div>
                        <div className='col-4'>
                            <label className="col-sm-6 col-form-label-sm">Tanggal Aju</label>
                            <div className="col-sm-6">
                                <input type="text" className="col-sm-12 form-control-sm" name="tanggal_aju" defaultValue={formatDateString(datappm.tanggalAju)} disabled />
                            </div>
                        </div>
                        <div className='col-4'>
                            <label className="col-sm-6 col-form-label-sm">Tanggal Ekspor</label>
                            <div className="col-sm-6">
                                <input type="text" className="col-sm-12 form-control-sm" name="tanggal_aju" defaultValue={formatDateString(datappm.tanggalTibaBerangkat)} disabled />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className='col-12'>
                            <label className="col-sm-4 col-form-label-sm">UPT</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={upt} disabled />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className='col-6'>
                            <label className="col-sm-4 col-form-label-sm">Pengirim</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.namaTrader} disabled />
                            </div>
                        </div>
                        <div className='col-6'>
                            <label className="col-sm-4 col-form-label-sm">Penerima</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="tanggal_aju" defaultValue={datappm.namaPartner} disabled />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className='col-4'>
                            <label className="col-sm-4 col-form-label-sm">Jenis Komoditi</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={jnsKomoditi} disabled />
                            </div>
                        </div>
                        <div className='col-4'>
                            <label className="col-sm-4 col-form-label-sm">Maksud Kegiatan</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={maksudKegiatan} disabled />
                            </div>
                        </div>
                        <div className='col-4'>
                            <label className="col-sm-4 col-form-label-sm">Negara Tujuan</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={negPartner} disabled />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={handleCloseViewProses}><FaChevronCircleLeft/> Kembali</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ModalViewProses